import type { RouteLocationNormalized } from 'vue-router'

export interface Route extends RouteLocationNormalized {}

export function isSearchRoute(route: Route) {
  return routeMatchesApp(route, 'search') || routeMatchesApp(route, 'maps')
}

export function isAccountRoute(route: Route) {
  const accountRouteNames = [
    'account',
    'account-allocation-alerts',
    'account-bookings',
    'account-dashboard',
    'account-reviews',
    'account-settings',
    'favourites',
  ]
  return route?.matched
    ? route.matched.some((match) =>
        accountRouteNames.includes(match.name as string),
      )
    : false
}

export function isCampsiteDetailsRoute(route: Route) {
  return routeMatchesApp(route, 'campsite-details')
}

function routeMatchesApp(route: Route, app: string) {
  return route?.matched
    ? route.matched.some((match) => match.meta?.app === app)
    : false
}
